import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-google-places-autocomplete',
  templateUrl: './google-places-autocomplete.component.html',
  styleUrls: ['./google-places-autocomplete.component.scss']
})
export class GooglePlacesAutocompleteComponent implements OnInit {
  @Input() placeholder: string = 'Search for an address';
  @Output() placeSelected = new EventEmitter<any>();
  @ViewChild('placesInput') placesInput!: ElementRef;

  autocomplete: google.maps.places.Autocomplete | null = null;
  private googleMapsScript: HTMLScriptElement | null = null;

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    this.loadGoogleMapsScript();
  }

  private loadGoogleMapsScript(): void {
    // Check if the script is already loaded
    if (window.google && window.google.maps) {
      this.initAutocomplete();
      return;
    }

    // Create the script element
    this.googleMapsScript = document.createElement('script');
    this.googleMapsScript.type = 'text/javascript';
    this.googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${environment.timezoneApiKey}&libraries=places`;
    this.googleMapsScript.onload = () => {
      this.ngZone.run(() => {
        this.initAutocomplete();
      });
    };

    document.body.appendChild(this.googleMapsScript);
  }

  private initAutocomplete(): void {
    // Wait for the ViewChild to be available
    if (!this.placesInput) {
      setTimeout(() => this.initAutocomplete(), 100);
      return;
    }

    this.ngZone.run(() => {
      // Add a class to the input element to ensure proper styling
      this.placesInput.nativeElement.classList.add('google-places-input');

      // Create the autocomplete instance with additional options
      this.autocomplete = new google.maps.places.Autocomplete(this.placesInput.nativeElement, {
        types: ['address']
      });

      // Add event listener for place selection
      this.autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = this.autocomplete!.getPlace();
          this.placeSelected.emit(place);
        });
      });

      // Add a MutationObserver to ensure the dropdown is properly positioned
      // This helps with z-index issues in modals
      setTimeout(() => {
        const pacContainers = document.getElementsByClassName('pac-container');
        if (pacContainers.length > 0) {
          // Force the pac-container to be a child of the modal
          const modalBody = this.placesInput.nativeElement.closest('.modal-body');
          if (modalBody) {
            for (let i = 0; i < pacContainers.length; i++) {
              const container = pacContainers[i] as HTMLElement;
              container.style.zIndex = '9999';
              container.style.position = 'absolute';
            }
          }
        }
      }, 300);
    });
  }
}
